var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"space",class:{
    tabs: true,
    active: _vm.activeSlider,
    scroll: _vm.mobile,
  }},[_c('div',{class:{
      tabs__btn: true,
      'tabs__btn--back': true,
      disable: !_vm.slideIndex,
    },on:{"click":function($event){return _vm.backSlide()}}},[_c('img',{attrs:{"src":require('@/assets/svg/play.svg')}})]),_c('div',{staticClass:"tabs__track",style:({ transform: _vm.transform })},[_c('div',{ref:"content",staticClass:"tabs__wrapper"},[_vm._t("default")],2)]),_c('div',{class:{
      tabs__btn: true,
      'tabs__btn--next': true,
      disable: _vm.slideIndex === _vm.maxIndex,
    },on:{"click":function($event){return _vm.nextSlide()}}},[_c('img',{attrs:{"src":require('@/assets/svg/play.svg')}})])])}
var staticRenderFns = []

export { render, staticRenderFns }